import SkTechApiClient from "./base/SkTechApiClient";

export type PaymentSystem = {
        id: number;
        name: string;
}

export default class CountryPaymentSystemApiClient extends SkTechApiClient {
    public GetAllAvailablePaymentSystems = async (countryId: number): Promise<PaymentSystem[]> => {
        return await this.Get(`/api/CountryPaymentSystem/GetAllAvailablePaymentSystems/${countryId}`)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                }
                throw new Error("Failed to fetch available payment systems.");
            })
            .catch(function (error) {
                console.error("Error fetching available payment systems:", error);
                throw error;
            });
    };
}
